import { CLEAR_FORM_ERRORS } from 'root/src/client/logic/form/actionIds'
import dissocPath from 'ramda/src/dissocPath'

export const reducer = (state, { moduleKey }) => dissocPath(['form', moduleKey, 'fieldErrors'], state)

export default {
	[CLEAR_FORM_ERRORS]: reducer,
}
